import { useRef, useState } from 'react';
import FullImageViewerDialog from '../../../components/community/FullImageViewerDialog';

interface PictureGridProps {
  urls: string[];
}

const PictureGrid = ({ urls }: PictureGridProps) => {
  const count = Math.min(urls.length, 4);
  const gridClass =
    count === 1
      ? 'grid-cols-1 grid-rows-1'
      : count === 2
        ? 'grid-cols-2 grid-rows-1'
        : 'grid-cols-2 grid-rows-2';

  const displayedUrls = urls.slice(0, 4);
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);
  const focusRef = useRef<HTMLDivElement | null>(null);

  const openImage = (index: number) => {
    setCurrentIndex(index);
    setCurrentUrl(displayedUrls[index]);
  };

  const closeImage = () => {
    setCurrentIndex(null);
    setCurrentUrl(null);
  };

  const handleNextImage = () => {
    if (currentIndex === null) return;
    const nextIndex = (currentIndex + 1) % displayedUrls.length;
    setCurrentIndex(nextIndex);
    setCurrentUrl(displayedUrls[nextIndex]);
  };

  const handlePrevImage = () => {
    if (currentIndex === null) return;
    const prevIndex =
      (currentIndex === 0 ? displayedUrls.length - 1 : currentIndex - 1) % displayedUrls.length;
    setCurrentIndex(prevIndex);
    setCurrentUrl(displayedUrls[prevIndex]);
  };

  return (
    <div>
      <div
        className={`grid ${gridClass} gap-[2px] w-[182px] h-[96px] rounded-[16px] overflow-hidden bg-surface-lv2 border border-separator1`}
        ref={focusRef}
      >
        {displayedUrls.map((url, index) => (
          <div key={url} className={count === 3 && index === 0 ? 'row-span-2' : ''}>
            <button type="button" className="w-full h-full" onClick={() => openImage(index)}>
              <img src={url} alt="" className="w-full h-full object-cover cursor-zoom-in" />
            </button>
          </div>
        ))}
      </div>
      {currentUrl && (
        <FullImageViewerDialog
          focusRef={focusRef}
          isOpen={!!currentUrl}
          imageUrl={currentUrl}
          onClosed={closeImage}
          onPrevImage={displayedUrls.length > 1 ? handlePrevImage : undefined}
          onNextImage={displayedUrls.length > 1 ? handleNextImage : undefined}
        />
      )}
    </div>
  );
};

export default PictureGrid;
